/**
 * all actions for fund state
 *
 * Created by Paul on 9/5/19
 */

import C from '../constants'

// action to show/hide loader
export const showFundLoader = booleanVal => {
    return {
        type: C.SET_FUND_LOADER,
        payload: booleanVal
    }
}

// action to set fund info data
// payload is the complete fund info data
export const setFundInfoData = objectVal => {
    return {
        type: C.SET_FUND_INFO_DATA,
        payload: objectVal
    }
}


// action to set fund memebers and trustees data
// payload is the complete fund info data
export const setMembersTrusteesInfoData = objectVal => {
    return {
        type: C.SET_MEMBERS_TRUSTEES_DATA,
        payload: objectVal
    }
}


// action to set company details
// payload is the complete fund info data
export const setCompanyDetailsData = objectVal => {
    return {
        type: C.SET_COMPANY_DETAILS_DATA,
        payload: objectVal
    }
}

// action to set the fund source and id for fetch
// payload is source + id
export const setFundId = objectVal => {
    return {
        type: C.SET_FUND_ID,
        payload: objectVal
    }
}

// action to show/hide loader
export const showFundOverallPositionLoader = booleanVal => {
    return {
        type: C.SET_FUND_POSITION_LOADER,
        payload: booleanVal
    }
}

// action to set fund position
export const setFundPosition = objectVal => {
    return {
        type: C.SET_FUND_POSITION,
        payload: objectVal
    }
}

// action to set fund position
export const setFundAssetSummary = objectVal => {
    return {
        type: C.SET_FUND_ASSET_SUMMARY,
        payload: objectVal
    }
}

// action to show/hide loader
export const showFundDetailedAssetPositionLoader = booleanVal => {
    return {
        type: C.SET_FUND_DETAILED_ASSET_POSITION_LOADER,
        payload: booleanVal
    }
}

// action to set fund asset position
export const setFundDetailedAssetPosition = objectVal => {
    return {
        type: C.SET_FUND_DETAILED_ASSET_POSITION,
        payload: objectVal
    }
}

// action to show/hide loader
export const showFundCashReconciliationLoader = booleanVal => {
    return {
        type: C.SET_FUND_CASH_RECONCILIATION_LOADER,
        payload: booleanVal
    }
}

// action to set fund cash reconciliation data
export const setFundCashReconciliationData = objectVal => {
    return {
        type: C.SET_FUND_CASH_RECONCILIATION_DATA,
        payload: objectVal
    }
}

// action to show/hide loader
export const showFundContributionsLoader = booleanVal => {
    return {
        type: C.SET_FUND_CONTRIBUTIONS_LOADER,
        payload: booleanVal
    }
}

// action to set fund contributions data
export const setFundContributionsData = objectVal => {
    return {
        type: C.SET_FUND_CONTRIBUTIONS_DATA,
        payload: objectVal
    }
}

// action to set fund form
// payload is the fund form
export const setCreateFundForm = objectVal => {
    return {
        type: C.SET_CREATE_FUND_FORM,
        payload: objectVal
    }
}

// action to show/hide loader
export const showSubmittingFundLoader = booleanVal => {
    return {
        type: C.SET_SUBMITTING_FUND_LOADER,
        payload: booleanVal
    }
}

export const clearFundForm = objectVal => {
    return {
        type: C.CLEAR_FUND_FORM,
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch the data
// NOTE: this will be picked up by the profile saga (sagas/profile.js)
export const getFundData = objectVal => {

    return {
        type: C.FETCH_FUND_DATA,
        payload: objectVal
    }
}

export const getFundOverallPosition = objectVal => {
    return {
        type: C.FETCH_FUND_OVERALL_POSITION,
        payload: objectVal
    }
}

export const getFundDetailedAssetPosition = objectVal => {
    return {
        type: C.FETCH_FUND_DETAILED_ASSET_POSITION,
        payload: objectVal
    }
}

export const getFundCashReconciliation = objectVal => {
    return {
        type: C.FETCH_FUND_CASH_RECONCILIATION,
        payload: objectVal
    }
}

export const requestBusinessEvents = objectVal => {
    return {
        type: C.REQUEST_BUSINESS_EVENTS,
        payload: objectVal
    }
}

export const requestCorporateActions = objectVal => {
    return {
        type: C.REQUEST_CORPORATE_ACTIONS,
        payload: objectVal
    }
}

export const getFundContributions = objectVal => {
    return {
        type: C.FETCH_FUND_CONTRIBUTIONS,
        payload: objectVal
    }
}

// call the action to create a new fund
export const createFundRequest = objectVal => {
    return {
        type: C.CREATE_NEW_FUND,
        payload: objectVal
    }
}

// call the action to create a new fund
export const setActiveStep = objectVal => {
    return {
        type: C.SET_ACTIVE_STEP,
        payload: objectVal
    }
}

export const fetchInProgressFund = objectVal => {
    return {
        type: C.FETCH_IN_PROGRESS_FUND,
        payload: objectVal
    }
}

export const updateFund = objectVal => {
    return {
        type: C.UPDATE_FUND,
        payload: objectVal
    }
}

export const setFundSummaryData = objectVal => {
    return {
        type: C.SET_FUND_SUMMARY_DATA,
        payload: objectVal
    }
}

export const getFundSummary = objectVal => {
    return {
        type: C.FETCH_FUND_SUMMARY_DATA,
        payload: objectVal
    }
}


// WEBPACK FOOTER //
// ./src/actions/fundActions.js